import React from 'react'
import FixtureTemplate from '../../FootballAPI/Fixture/FixtureTemplates/FixtureTemplate'

function UtenlandsProffScrollListtemplate({ playersFixture, fixture, type }) {
    const AVATAR_URL =
        'https://smorasstats.com/v4/wp-content/uploads/2020/01/5d5fe9333b21a2019-08-23hnesse-1.jpg'
    return (
        <React.Fragment>
            <div className="card px-2 py-1">
                {playersFixture?.map((player, index) => {
                    return <small key={index}>{player?.player_name}</small>
                })}
            </div>

            <FixtureTemplate fixture={fixture} type={type} />
        </React.Fragment>
    )
}
export default UtenlandsProffScrollListtemplate
